import React, { Component } from 'react';
import { BasePanel } from './PickerPanel';
import Footer from './panel/BaseFooter';
import { DateUtil } from './util';

// mode的权重，用于mode不同时的选择比较基准
const COMPARE_MODE = {
    decade: 5,
    year: 4,
    month: 3,
    week: 2,
    date: 1,
};

class RangePanel extends Component {
    constructor(props) {
        super(props);
        this.state = { hoverDate: null };
        this.realPanelRef = React.createRef();
        this.leftPanelRef = React.createRef();
        this.rightPanelRef = React.createRef();
    }

    render () {
        let { value, focusIndex, functions, mode, viewDate, picker, functionValue, pickerPanelProps } = this.props,
            [startPanelValue, endPanelValue] = viewDate;

        value = value[focusIndex];
        viewDate = viewDate[focusIndex];

        let panelProps = {
            ...this.props,
            onDateMouseEnter: this.onDateMouseEnter,
            onDateMouseLeave: this.onDateMouseLeave,
            // 不使用PickerPanel的扩展
            value,
            viewDate,
        };

        return <div className={`picker-panel panel-type-${picker} range-panel`}>
            <div className="picker-panel-container">
                {(picker === 'dateTime' || picker === 'time') ? <BasePanel
                    {...panelProps}
                    ref={this.realPanelRef}
                    functions={functions}
                    onPanelChange={this.onPanelChange.bind(this, focusIndex)}
                    mode={mode[focusIndex]}
                    getCellClassName={this.getCellClassName.bind(this, focusIndex)}
                    functionValue={functionValue[focusIndex]}
                /> : <>
                    <BasePanel
                        {...panelProps}
                        panelWrapperProps={pickerPanelProps?.[0]}
                        viewDate={startPanelValue}
                        onPanelChange={this.onPanelChange.bind(this, 0)}
                        mode={mode[0]}
                        getCellClassName={this.getCellClassName.bind(this, 0)}
                        ref={this.leftPanelRef}
                        functionValue={functionValue[0]}
                    />
                    <BasePanel
                        {...panelProps}
                        panelWrapperProps={pickerPanelProps?.[1]}
                        viewDate={endPanelValue}
                        onPanelChange={this.onPanelChange.bind(this, 1)}
                        mode={mode[1]}
                        getCellClassName={this.getCellClassName.bind(this, 1)}
                        ref={this.rightPanelRef}
                        functionValue={functionValue[1]}
                    />
                </>}
            </div>
            {<Footer {...this.props}></Footer>}
        </div>;
    }

    onPanelChange = (index, ...rest) => {
        this.props.onPanelChange(...rest, index);
    }

    getCellClassName = (index, currentDate) => {
        let { value, mode, viewDate } = this.props;
        value = [...value];

        let [startValue, endValue] = value;
        // 选择过程中，如果开始日期大于结束日期，则结束日期没有选中效果
        if (DateUtil.isAfter(startValue, endValue, mode[index])) {
            // value = focusIndex === 1 ? [startValue] : ["", endValue];
            [endValue, startValue] = [startValue, endValue];
        }

        let selectedStart = DateUtil.isSame(currentDate, startValue, 'date'),
            selectedEnd = DateUtil.isSame(currentDate, endValue, 'date'),
            currentMonth = DateUtil.isSame(currentDate, viewDate[index], 'month');

        return {
            'picker-cell-range-selected': currentMonth && this.isRangeSelected(currentDate, startValue, endValue),
            'picker-cell-selected': currentMonth && (selectedStart || selectedEnd),
            // 下面两个用来连接顶点和线
            'picker-cell-range-selected-start': currentMonth && selectedStart && endValue && mode[index] !== 'year',
            'picker-cell-range-selected-end': currentMonth && selectedEnd && startValue && mode[index],
            ...(currentMonth ? this.getHoverClassName(currentDate, startValue, endValue) : {}),

        };
    }

    isRangeSelected = (currentDate, startValue, endValue) => {
        let { mode } = this.props;
        let compareMode = this.getMinModeCompare(mode);
        return startValue && endValue && DateUtil.isBefore(currentDate, endValue, compareMode) && DateUtil.isAfter(currentDate, startValue, compareMode);
    }

    //比较两个mode，返回范围更小的mode
    getMinModeCompare = ([mode1, mode2]) => { //本函数的if顺序不可变，由范围大到小排序, 遍历完每个mode后进入下一范围判断
        if(mode1 === mode2) {return mode1;}
        return COMPARE_MODE[mode1] > COMPARE_MODE[mode2] ? mode2: mode1;
    }

    getHoverClassName = (currentDate, startValue, endValue) => {
        let { focusIndex, mode } = this.props,
            { hoverDate } = this.state;
        let classNames = { 'picker-cell-hover': DateUtil.isSame(currentDate, hoverDate, mode[focusIndex]) };
        let compareMode = this.getMinModeCompare(mode);

        if (hoverDate) {
            if (focusIndex === 0) {
                if (endValue) {
                    Object.assign(classNames, {
                        'picker-cell-range-hover': this.isRangeSelected(currentDate, hoverDate, endValue),
                        'picker-cell-range-hover-start': DateUtil.isBefore(hoverDate, endValue, compareMode) && DateUtil.isSame(currentDate, hoverDate, compareMode),
                        'picker-cell-range-hover-end': DateUtil.isBefore(hoverDate, endValue, compareMode) && DateUtil.isSame(currentDate, endValue, compareMode),
                    });
                }
            }
            if (focusIndex === 1) {
                if (startValue) {
                    Object.assign(classNames, {
                        'picker-cell-range-hover': this.isRangeSelected(currentDate, startValue, hoverDate),
                        'picker-cell-range-hover-start': DateUtil.isBefore(startValue, hoverDate, compareMode) && DateUtil.isSame(currentDate, startValue, compareMode),
                        'picker-cell-range-hover-end': DateUtil.isBefore(startValue, hoverDate, compareMode) && DateUtil.isSame(currentDate, hoverDate, compareMode),
                    });
                }
            }
        }
        return classNames;
    }

    onDateMouseEnter = date => {
        this.setState({ hoverDate: date });
        const { onDateMouseEnter } = this.props;
        return onDateMouseEnter && onDateMouseEnter(date);
    }

    onDateMouseLeave = date => {
        this.setState({ hoverDate: null });
        const { onDateMouseLeave } = this.props;
        return onDateMouseLeave && onDateMouseLeave(date);
    }

    onKeyDown = e => {
        const { focusIndex, picker } = this.props;
        if(picker === 'dateTime' || picker === 'time') {
            return this?.realPanelRef?.current?.onKeyDown?.(e);
        } else {
            if(focusIndex === 0){
                return this?.leftPanelRef?.current?.onKeyDown?.(e);
            } else if(focusIndex === 1){
                return this?.rightPanelRef?.current?.onKeyDown?.(e);
            }
        }
    }
}

export default RangePanel;